import { useCallback } from 'react';

export const useXpointDownloadVerifyApp = () => {
    return useCallback(() => {
        const url = new URL('https://install.xpoint.tech', location.href);

        window.open(url.toString(), '_blank');
    }, []);
};
